/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PresentationCard_presentation = {
    readonly rowId: string;
    readonly description: string | null;
    readonly prettyUrl: string;
    readonly title: string;
    readonly videoSourceUrl: string | null;
    readonly presenterFirstName: string | null;
    readonly presenterLastName: string | null;
    readonly presenter: {
        readonly " $fragmentRefs": FragmentRefs<"UserItem_user">;
    } | null;
    readonly " $refType": "PresentationCard_presentation";
};
export type PresentationCard_presentation$data = PresentationCard_presentation;
export type PresentationCard_presentation$key = {
    readonly " $data"?: PresentationCard_presentation$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PresentationCard_presentation">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PresentationCard_presentation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoSourceUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presenterFirstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presenterLastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "presenter",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserItem_user"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Presentation",
  "abstractKey": null
};
(node as any).hash = 'e57697c62d2de87bd5e779c7a41dc858';
export default node;
